

















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { SixMinutesWalk } from '@/jsonapi/DetailedPatient'
import { currentTimestamp, toReadableTime, toTimestamp } from '@/utils/time'

@Component({})
export default class SixMinuteWalks extends Vue {
  @Prop({ default: false }) edit!: boolean
  @Prop({ required: true }) value!: SixMinutesWalk[]
  @Prop({ default: null }) timezone!: string

  private date: string = ''
  private showDatePickerIndex: number = -1

  private updateEvent() {
    this.$emit('input', this.value)
  }

  private handleDate(index) {
    const timestamp = toTimestamp(this.date, this.timezone)
    this.value[index].timestamp = timestamp
    this.showDatePickerIndex = -1
  }

  private readableTime(timestamp: number) {
    return toReadableTime({ timestamp, format: 'YYYY-MM-DD', timezone: this.timezone })
  }

  private newWalk() {
    const date = new Date().toISOString().slice(0, 10)
    const timestamp = currentTimestamp()
    const walk: SixMinutesWalk = {
      distance: 0,
      timestamp,
    }
    this.value.push(walk)
    this.updateEvent()
  }

  private deleteWalk(index: number) {
    this.value.splice(index, 1)
    this.updateEvent()
  }
}
